<template>
  <div>
    <Header title="订单支付成功" :show="true" />
    <LoadingModal />
    <van-panel v-show="!$store.state.pageLoading">
      <div slot="header" class="dtitle">
        <i class="iconfont iconzhifuchenggong" />
        <br />
        <span>支付成功</span>
      </div>
      <van-divider />
      <div>
        <ul>
          <li>
            订单名称
            <span>{{ model.name }}</span>
          </li>
          <li>
            订单编号
            <span>{{ model.id }}</span>
          </li>
          <li>
            订单时间
            <span>{{ model.create_time }}</span>
          </li>
          <li v-if="model.origin_price">
            <!-- {{model.type==3?'服务原价':'商品原价'}} -->
            服务原价
            <span>￥{{ $formatMoney(model.origin_price, 1) }}</span>
          </li>
          <li v-if="!model.pay_card_id">
            支付金额
            <span>￥{{ $formatMoney(model.pay_money, 1) }}</span>
          </li>
          <li v-if="model.pay_balance">
            使用余额
            <span>￥{{ $formatMoney(model.pay_balance, 1) }}</span>
          </li>
          <li v-if="model.pay_cash">
            现金金额
            <span>￥{{ $formatMoney(model.pay_cash, 1) }}</span>
          </li>
          <li v-if="model.pay_card_id">
            卡券抵扣
            <span>{{ model.pay_card_id }}</span>
          </li>
          <li v-if="model.account">
            充值账号
            <span>{{ model.account }}</span>
          </li>
          <li v-if="model.type == 3">
            服务门店
            <span>{{ model.servicer_name }}</span>
          </li>
          <li v-if="model.type == 4 && isShow">
            到账时效
            <span>{{ model.time_tips }}</span>
          </li>
        </ul>
      </div>
      <div slot="footer" class="down">
        <van-button
          type="default"
          block
          :text="text"
          color="var(--depYelColor)"
          @click="returnBack"
          :disabled="disabled"
        />
      </div>
    </van-panel>
  </div>
</template>
 

<script>
import { getOrderInfo } from "api/user";
export default {
  data() {
    return {
      model: {},
      type: 0,
      isShow: false,
      text: "确定(5)",
      disabled: true,
    };
  },
  mounted() {
    this.getDetail();
    let time = 4;
    let interval = setInterval(() => {
      if (time > 0) {
        this.text = "确定(" + time + ")";
        time--;
      } else {
        clearInterval(interval);
        this.disabled = false;
        this.text = "确定";
      }
    }, 1000);
  },
  methods: {
    returnBack() {
      if (this.model.type == 15) {
        this.$push({
          path: "/orders",
          query: { type: "3" },
        });
        return;
      }
      const type = this.$store.state.globalOrderType;
      let jkda = this.$getItem("jkda");
      let jyb = this.$getItem("jyb");
      let cytj = this.$getItem("cytj");
      if (jkda) {
        this.$removeItem("jkda");
        this.$push({
          path: "/healthyCode",
          query: { type: "1" },
        });
      } else if (jyb) {
        this.$removeItem("jyb");
        location.assign("/clinic?lat=22.516969&lng=113.392608");
      } else if (cytj) {
        this.$removeItem("cytj");
        this.$push({
          path: "/showCheckQRcode",
        });
      } else {
        if (type === 2) {
          this.$push({
            path: "/coupons",
          });
        } else if (type === 1) {
          this.$push({
            path: "/orders",
            query: { type: "0" },
          });
        } else {
          this.$push({
            path: "/orders",
            query: { type: "2" },
          });
        }
      }
      // this.$store.commit("setGlobalOrderType", 0);
    },
    getDetail() {
      getOrderInfo(this.$route.query.id).then((res) => {
        if (res.status == 1) {
          let status = res.data.model.status;
          this.model = res.data.model;
          this.isShow =
            status == 1 || status == 3 || status == 5 ? true : false;
        } else {
          this.$error(res.msg);
        }
      });
      this.$store.commit("setPageLoading", false);
    },
  },
};
</script>
<style lang="less" scoped>
.iconfont {
  font-size: 90px;
}
.dtitle {
  text-align: center;
  color: #07c160;
  font-size: 25px;
  span {
    font-weight: bold;
  }
  margin-top: 0px;
  padding-top: 30px;
}
ul span {
  float: right;
  color: #000;
}
ul {
  margin: 15px;
  line-height: 1.7;
  font-size: 15px;
  color: #999;
}
.down {
  padding: 15px;
  p {
    word-wrap: break-word;
  }
}
</style>